import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import './AbroadInsurance.scss';
import { prepareSameWindowUrl } from '../../../../utilities/StringHelpers/StringHelpers';
import { abroadInsuranceCreateReportShowDetails } from '../../CollaborationInsuranceBlock/abroadInsurancReports';
import { setCurrentSubscriber } from '../../CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import { gaReportAbroadInsurance } from '../../CollaborationInsuranceBlock/abroadInsuranceGA';
import { abroadInsuranceEnum } from '../../CollaborationInsuranceBlock/abroadInsuranceGAEnum';

const AbroadInsurance = (props) => {
    const bottomMsg = 'מישהו טס איתך? לרכישת ביטוח למנוי נוסף >';
    const details = 'למידע ועדכון הפוליסה';
    const phone = ' ' + props.subscriber + ' ';
    const abroadInsuranceUrl = props.data?.epiStyleInitializationData?.abroadInsurancePage;
    const [expDate, setExpDate] = useState(null);

    useEffect(() => {
        let insuranceExpDate ='';
        if (props.insuranceData != undefined && props.insuranceData?.exist) {
            if (props.insuranceData?.expirationDate != null) {
                let date = props.insuranceData?.expirationDate;
                insuranceExpDate = (date.slice(6, 8) + '.' + date.slice(4, 6) + '.' + date.slice(0, 4));
                setExpDate(insuranceExpDate);
            }
            else {
                setExpDate('');
            }
        }
        if (props.subscriber != '' && insuranceExpDate != '' && props.insuranceData?.exist) {
            let userData = props.authentication.loginData?.userDetails;
            let channel = "WebsitePrivate";
            if (props.customerType?.isBusiness && !props.customerType?.isPrivate) {
                channel = "WebsiteBusiness";
            }

            abroadInsuranceCreateReportShowDetails(channel, 'Ongoing', 'Insurance Info Displayed'
                , insuranceExpDate, userData?.firstName + ' ' + userData?.lastName, '', props.subscriber, userData?.IDNumber);

            gaReportAbroadInsurance(abroadInsuranceEnum.InsuranceExist);

        }

    }, []);

        return (
            <div className='abroad-additional-services-item'>
                <div className='description-container'>
                        <div className='item-title-1'>יש לך ביטוח נסיעה לחו"ל</div>
                        <div className='item-title-2'>
                            למנוי
                            <span style={{ fontWeight: "bold" }}>{phone}</span>
                            קיים ביטוח נסיעה לחו"ל עד
                            <span>&nbsp;</span>
                            <span style={{ fontWeight: "bold" }}>{expDate}</span>
                        </div>
                </div>
                <div className='action-container'>
                        <div className='action' onClick={() => {
                                props.setCurrentSubscriber(phone), prepareSameWindowUrl(abroadInsuranceUrl, props.context),
                                    abroadInsuranceCreateReportShowDetails('WebsitePrivate', 'Completed', 'Insurance Info Clicked'
                                        , expDate, userData?.firstName + ' ' + userData?.lastName, '', props.subscriber, userData?.IDNumber),
                                    gaReportAbroadInsurance(abroadInsuranceEnum.InfoButtonHullSheli);
                            }}>
                                {details}
                        </div>                
                        <div className='action' onClick={() => {
                            prepareSameWindowUrl(abroadInsuranceUrl, props.context),
                            abroadInsuranceCreateReportShowDetails('WebsitePrivate', 'Completed', 'Go To Insurance Page Clicked'
                                , '', userData?.firstName + ' ' + userData?.lastName, '', props.subscriber, userData?.IDNumber),
                            gaReportAbroadInsurance(abroadInsuranceEnum.AnotherInsButton);

                    }}>{bottomMsg}</div>
                </div>
            </div>
        );


}

const mapStateToProps = (state) => {
    return {
        authentication: state.authentication,
        insuranceData: state.cellcomAbroad.abroadPermanentInsuranceSocData,
        subscriber: state.cellcomAbroad.epiStyleInitializationData.businessIndividualLobby
            ? state.cellcomAbroad.businessIndividualData.selectedAccountNumber
            : state.cellcomAbroad.otpData.otpPhone || state.authentication.loginData.userDetails.contactNumber,
        data: state.cellcomAbroad,
        customerType: state.welcomeBlock?.welcomeState?.customerType,
    };
};

const mapDispatchToProps = {
    setCurrentSubscriber,
};

export default connect(mapStateToProps, mapDispatchToProps)(AbroadInsurance);
